import { Injectable } from '@angular/core';

import { FeatureFlagService } from './feature-flag.service';

export function initializeAppFeatureFlags(appInitService: FeatureFlagsInitService) {
  return (): Promise<any> => {
    return appInitService.init();
  };
}

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsInitService {
  constructor(private featureFlagService: FeatureFlagService) { }

  init(): Promise<Array<void>> {
    const appInitializationPromise = this.featureFlagService.initialize();
    return Promise.all([appInitializationPromise]);
  }

  initialize(): Promise<void> {
    return this.featureFlagService.initialize();
  }
}
